// dopTranslations.ts

export const dopTranslations: Record<string, any> = {
    En: {
        uniqueCode: 'Unique identification code of the product type',
        intendedUse: 'Intended use',
        manufacturer: 'Manufacturer',
        representative: 'Authorized representative',
        system: 'System/systems of AVCP',
        standard: 'Harmonized standard',
        notifiedBody: 'Notified Body/Bodies',
        document: 'European Assessment Document',
        declared: 'Declared performance',

        insulation: 'Insulation',
        reactionToFire: 'Reaction to fire',
        fireResistance: 'Fire resistance',
        material: 'Material External / Internal Sheets',
        thickness: 'Nominal thickness',
        declaredPerformance: 'Declared performance',
        keyFeatures: 'Key features performance',

        signedBy: 'Signed for and on behalf of the manufacturer by:',
        notes: 'Notes',
        fireDoc: 'Fire resistance test documentation is issued at the customer\'s request',
        bending: 'Bending moment capacities are given for sheet thickness 0.4/0.4',
        noTesting: 'In accordance with EN-14509, EN-13165 and the materials used, following performance is confirmed without testing',
        svojstva: 'The performance of the product identified above is in conformity with the set of declared performance/s. This declaration of performance is issued, in accordance with Regulation (EU) No 305/2011, under the sole responsibility of the manufacturer identified above.',
        declaration: 'Declaration of Performance',
    },

    De: {
        uniqueCode: 'Eindeutiger Kenncode des Produkttyps',
        intendedUse: 'Verwendungszweck',
        manufacturer: 'Hersteller',
        representative: 'Bevollmächtigter Vertreter',
        system: 'Bewertungssystem',
        standard: 'Harmonisierte Norm',
        notifiedBody: 'Benannte Stelle',
        document: 'Europäisches Bewertungsdokument',
        declared: 'Erklärte Leistung',

        insulation: 'Dämmung',
        reactionToFire: 'Brandverhalten',
        fireResistance: 'Feuerwiderstand',
        material: 'Material Außen / Innen',
        thickness: 'Nenndicke',
        declaredPerformance: 'Deklarierte Leistung',
        keyFeatures: 'Wesentliche Merkmale',

        signedBy: 'Unterzeichnet für und im Namen des Herstellers von:',
        notes: 'Hinweise',
        fireDoc: 'Prüfunterlagen zur Feuerbeständigkeit werden auf Anfrage des Kunden ausgestellt',
        bending: 'Biegemomentkapazitäten gelten für Blechdicke 0,4/0,4',
        noTesting: 'Gemäß EN-14509, EN-13165 und den verwendeten Materialien wurde diese Leistung ohne Prüfung bestätigt',
        svojstva: 'Die Leistung des oben genannten Produkts entspricht den erklärten Leistungen. Diese Leistungserklärung wird gemäß der Verordnung (EU) Nr. 305/2011 unter der alleinigen Verantwortung des oben genannten Herstellers ausgestellt.',
        declaration: 'Leistungserklärung',
    },

    Es: {
        uniqueCode: 'Código de identificación único del producto',
        intendedUse: 'Uso previsto',
        manufacturer: 'Fabricante',
        representative: 'Representante autorizado',
        system: 'Sistema de evaluación',
        standard: 'Norma armonizada',
        notifiedBody: 'Organismo notificado',
        document: 'Documento de evaluación europeo',
        declared: 'Prestaciones declaradas',

        insulation: 'Aislamiento',
        reactionToFire: 'Reacción al fuego',
        fireResistance: 'Resistencia al fuego',
        material: 'Material exterior / interior',
        thickness: 'Espesor nominal',
        declaredPerformance: 'Prestaciones declaradas',
        keyFeatures: 'Características clave',

        signedBy: 'Firmado por y en nombre del fabricante por:',
        notes: 'Notas',
        fireDoc: 'La documentación de resistencia al fuego se emite a solicitud del cliente',
        bending: 'Las capacidades de momento de flexión se dan para espesor de chapa 0,4/0,4',
        noTesting: 'De acuerdo con EN-14509, EN-13165 y los materiales utilizados, esta característica se confirma sin ensayo',
        svojstva: 'Lastnosti zgoraj navedenega proizvoda so v skladu z navedenimi lastnostmi. Ta izjava o lastnostih je izdana v skladu z Uredbo (EU) št. 305/2011 na izključno odgovornost zgoraj navedenega proizvajalca.',
        declaration: 'Declaración de prestaciones',
    },

    Sl: {
        uniqueCode: 'Enotna identifikacijska oznaka vrste proizvoda',
        intendedUse: 'Predvidena uporaba',
        manufacturer: 'Proizvajalec',
        representative: 'Pooblaščeni zastopnik',
        system: 'Sistem ocenjevanja',
        standard: 'Harmonizirani standard',
        notifiedBody: 'Priglašeni organ',
        document: 'Evropski ocenjevalni dokument',
        declared: 'Deklarirane lastnosti',

        insulation: 'Izolacija',
        reactionToFire: 'Reakcija na ogenj',
        fireResistance: 'Požarna odpornost',
        material: 'Material zunaj / znotraj',
        thickness: 'Nazivna debelina',
        declaredPerformance: 'Deklarirane lastnosti',
        keyFeatures: 'Ključne značilnosti',

        signedBy: 'Podpisano za proizvajalca in v njegovem imenu:',
        notes: 'Opombe',
        fireDoc: 'Dokumentacija o požarni odpornosti se izda na zahtevo kupca',
        bending: 'Kapacitete upogibnega momenta veljajo za debelino pločevine 0,4/0,4',
        noTesting: 'V skladu z EN-14509, EN-13165 in uporabljenimi materiali je lastnost potrjena brez testiranja',
        svojstva: 'El rendimiento del producto identificado anteriormente es conforme con el conjunto de prestaciones declaradas. Esta declaración de prestaciones se emite, de acuerdo con el Reglamento (UE) nº 305/2011, bajo la exclusiva responsabilidad del fabricante identificado anteriormente.',
        declaration: 'Izjava o lastnostih',
    }
}